import { invoke } from "@tauri-apps/api/core";
const HQ_API_URL = import.meta.env.VITE_HQ_API_URL;
const HQ_API_USER_LOGIN = "/users/login";
const USER_PROFILE_URL = `${HQ_API_URL}/users`;
const get = async (url, init = {}) => {
    let redirectToLogin = false;
    const response = await fetch(url, { ...init, credentials: "include" })
        .then((response) => {
        if (response.status && (response.status === 403 || response.status === 401)) {
            redirectToLogin = true;
            return null;
        }
        return response.json();
    })
        .catch((error) => {
        // fetch() rejects on network failure (offline, DNS, CORS, etc.), not on HTTP error
        // status - those are handled above via response.status. A rejection here is never
        // itself a 401/403, so it should not trigger a login redirect.
        console.log(`apiUtils GET Failed... ${error}`);
    });
    if (redirectToLogin) {
        window.location.assign(`${HQ_API_URL + HQ_API_USER_LOGIN}?redirect_uri=${encodeURIComponent(window.location.href)}`);
        return null;
    }
    return response;
};
export async function getAtcAccessToken() {
    if (window.__TAURI__) {
        const tokenData = await invoke("get_token_data").catch(() => null);
        if (typeof tokenData?.access_token === "string") {
            return tokenData?.access_token;
        }
    }
    return get(USER_PROFILE_URL).then((response) => {
        console.log("Access token updated for ATC Hub connection");
        return response.accessToken;
    });
}
//# sourceMappingURL=posconApi.js.map